import Cookies from "js-cookie";
import { createFilterExpander } from "src/decidim/volunteering/shared/filter_expander";
import "src/decidim/volunteering/offers/offer_remaining_time";
const DESKTOP_BREAKPOINT = "1024px";
$(() => {
  const subscriptionDialog = Decidim.currentDialogs["offers-subscription-dialog"];
  const resetSubscriptionForm = () => {
    const subscriptionForm = subscriptionDialog.dialog.querySelector("form");
    subscriptionForm.querySelectorAll(".is-invalid-input").forEach((element) => {
      element.classList.remove("is-invalid-input");
      element.removeAttribute("aria-invalid");
      element.removeAttribute("data-invalid");
      const errorElementId = element.getAttribute("aria-describedby");
      if (errorElementId) {
        const errorElement = document.getElementById(errorElementId);
        if (errorElement) {
          errorElement.classList.remove("is-visible");
        }
      }
    });
    subscriptionForm.querySelectorAll(".form-error.is-visible").forEach((element) => element.classList.remove("is-visible"));
  };
  subscriptionDialog.dialog.addEventListener("close.dialog", () => resetSubscriptionForm());
  const closeFiltersBtn = document.querySelectorAll("[id=close-filters-btn]");
  const filters = document.getElementById("filters");
  const offerSubscriptionDialogContent = document.getElementById("offers-subscription-dialog-content");
  offerSubscriptionDialogContent.addEventListener("ajax:success", (e) => {
    Decidim.currentDialogs["offers-subscription-dialog"].close();
    Decidim.currentDialogs["offers-subscription-success-dialog"].open();
    setTimeout(() => resetSubscriptionForm());
  });
  let offersList = getOffersListNode();
  const availableLayouts = ["list-layout", "table-layout"];
  const $offers = $("#offers");
  createFilterExpander({ rootSelector: "#category-filters", filterItemSelector: ".category_element" }).init();
  createFilterExpander({ rootSelector: "#district-filters", filterItemSelector: ".district_element" }).init();
  createFilterExpander({ rootSelector: "#format-type-filters", filterItemSelector: ".form_element" }).init();
  createFilterExpander({ rootSelector: "#offer-type-filters", filterItemSelector: ".offer_type_element" }).init();
  $offers.on("ow:offers:update", (_, offers) => {
    updateMapOffers(offers);
  });
  function updateCardLayoutClass(layout) {
    const cards = [...document.querySelectorAll("#offers .offer-card")];
    cards.forEach((card) => {
      card.classList.toggle("vertical", layout === "table-layout");
    });
  }
  $(document).on("change", "#ow-layout-switcher", (event) => {
    if (!offersList.isConnected) {
      offersList = getOffersListNode();
    }
    const selectedOption = event.target.value;
    availableLayouts.forEach((item) => offersList.classList.remove(item));
    offersList.classList.add(selectedOption);
    storeSelectedSwitchOption(selectedOption);
    updateCardLayoutClass(selectedOption);
  });
  $(document).on("click", "#show-filters-btn", (event) => {
    filters.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
    closeFiltersBtn[0].focus();
  });
  closeFiltersBtn.forEach((element) => {
    element.addEventListener("click", () => {
      hideFilters();
    });
  });
  window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT})`).addEventListener("change", () => {
    hideFilters();
  });
  function hideFilters() {
    filters.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  }
  function getOffersListNode() {
    return document.getElementById("offers-list");
  }
  function storeSelectedSwitchOption(value) {
    Cookies.set("offers_layout", value);
  }
  function updateMapOffers(offers) {
    const $map = $("#map");
    let mapId = $map.attr("id");
    if (!mapId) {
      mapId = `map-${Math.random().toString(36).substr(2, 9)}`;
      $map.attr("id", mapId);
    }
    const mapConfig = $map.data("decidim-map");
    mapConfig.markers = offers;
    const ctrl = window.Decidim.createMapController(mapId, mapConfig);
    const map = ctrl.load();
    $map.data("map", map);
    $map.data("map-controller", ctrl);
    $map.trigger("configure.decidim", [map, mapConfig]);
    ctrl.start();
    $map.trigger("ready.decidim", [map, mapConfig]);
  }
});
